<template>
  <div class="range-slider">
    <span class="decrease" @click="decrease"></span>
    <input
        type="range"
        :value="data.value"
        :min="data.from"
        :max="data.to"
        :step="step"
        @change="calculateSelection"
        @input="calculateSelection"
    >
    <span class="increase" @click="increase"></span>
    <span><strong>{{ data.value }}</strong> {{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "RangeSlider",
  props: {
    type: String,
    data: Object
  },
  computed: {
    step() {
      return this.getStep();
    },
    label() {
      return this.$parent.rangeLabel(this.type)
    }
  },
  methods: {
    getStep(divergence=0) {
      if (typeof this.data.step === 'number') {
        return this.data.step;
      }

      for (const [threshold, step] of Object.entries(this.data.step).reverse()) {
        if (this.data.value + divergence >= parseInt(threshold)) {
          return step;
        }
      }

      return 1;
    },
    calculateSelection(event) {
      let value = event.target.value;

      if (value < this.data.from) {
        value = this.data.from;
      }

      if (value > this.data.to) {
        value = this.data.to;
      }

      this.$root.$emit('rangeSliderChanged', this.type, parseInt(value))
    },

    decrease() {
      let value = this.data.value - this.getStep(-1);

      if (value < this.data.from) {
        value = this.data.from;
      }

      this.$root.$emit('rangeSliderChanged', this.type, value)
    },

    increase() {
      let value = this.data.value + this.getStep(+1);

      if (value > this.data.to) {
        value = this.data.to;
      }

      this.$root.$emit('rangeSliderChanged', this.type, value)
    }
  }
}
</script>
